module.exports = __webpack_public_path__ + "media/Loops 90 Brass.75806cd3.wav";